import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantService } from '../../core/tenant/tenant.service';

export interface EmailTemplate {
  content: string;
  subject: string;
}

// Every template for a tenant lives at emailTemplates/{tenantId}/templates/{key}
// (e.g. 'trainingEN', 'chatMessageDE'), so adding a template never means
// adding a new Firestore collection or a new service method.
@Injectable({
  providedIn: 'root'
})
export class EmailTemplatesService {

  constructor(
    private afs: AngularFirestore,
    private tenant: TenantService,
  ) {
  }

  private templatesCollection(tenantId: string) {
    return this.afs.collection<EmailTemplate>(`emailTemplates/${tenantId}/templates`);
  }

  getAllTemplates(tenantId: string = this.tenant.current.id): Observable<{ [key: string]: EmailTemplate }> {
    return this.templatesCollection(tenantId).snapshotChanges().pipe(
      map(actions => {
        const templates: { [key: string]: EmailTemplate } = {};
        actions.forEach(action => {
          templates[action.payload.doc.id] = action.payload.doc.data();
        });
        return templates;
      })
    );
  }

  getTemplate(key: string, tenantId: string = this.tenant.current.id): Observable<EmailTemplate> {
    return this.templatesCollection(tenantId).doc<EmailTemplate>(key).valueChanges();
  }

  setTemplate(key: string, data: EmailTemplate, tenantId: string = this.tenant.current.id) {
    return this.templatesCollection(tenantId).doc(key).set(data);
  }
}
